import styled from "styled-components";
import { tokens } from "../../../design/tokens";

export const AmountText = styled.h1`
  color: ${tokens.color.textWhite};
`;

export const WalletContainer = styled.article`
  width: 100%;

  display: flex;
  justify-content: flex-start;
  gap: 16px;
  flex-wrap: wrap;
`;

interface IWalletCard {
  accent?: "gold" | "amber";
}

export const WalletCard = styled.figure<IWalletCard>`
  width: 220px;
  min-height: 96px;
  margin: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  background-color: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-left: 3px solid
    ${({ accent }) =>
      accent === "amber" ? tokens.color.focusAmber : tokens.color.marqueeGold};
  border-radius: ${tokens.radius.md};

  padding: 16px 20px;
  gap: 8px;
`;

export const WalletTitle = styled.h4`
  text-align: left;
  color: ${tokens.color.textAsh};
  margin: 0;
  font-size: 0.85rem;
  font-weight: 500;
`;

export const WalletValue = styled.span`
  display: flex;
  align-items: baseline;
  font-size: 24px;
  color: ${tokens.color.textWhite};
  font-weight: 600;

  & > p {
    font-size: 14px;
    margin-right: 6px;
    color: ${tokens.color.textAsh};
  }
`;
